import { createContext } from "react";
import { Score } from "src/types";
import { ScoreDetailBuilder } from "./ScoreDetailBuilder";
import { Drilldown } from "./useDrilldown";
import { TabConfig } from "src/components/ScoreDetail/InnerTabs/ScoreDetailTabs";
import { ScoreWithVariation } from "src/services/ScoreService";
import { VariationsParams } from "../OlapScores/useVariations";
import { DimensionValue, MainScore } from "src/api/client-api/olapScores/olapScoresSchema";
import { OlapScoresParams } from "../OlapScores/useOlapScoresParams";
import { Post } from "src/api/client-api/post/postSchema";
import { OnLastLevelClickAction } from "src/components/ScoreDetail/Chart/Distribution/DistributionChartCore";
import { GetOnePost } from "src/api/client-api/post/useGetOnePost";
import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";
import type { ScoreDetailRemoteState } from "./scoreDetailRemoteState";

export type ScoreDetailContextInitialValues = {
    score: Score;
    scoresParams?: OlapScoresParams;
    olapScores?: MainScore;
    olapPrevScores?: MainScore;
    areAggregationsRequested?: boolean;
    fetchPostForAnswers?: FetchPostForAnswers;
    hideSeeMoreDetails?: (dimension: string) => boolean;
    selectedVariations?: VariationsParams;
    getDimensionValueLocalizedLabel?: (dimension: string, key: string | number) => string | null;
    getDimensionValuesColors?: (dimensionValues: Array<{ dimension: string; id: string | number }>) => string[];
    getDimensionValueDrilldownAction?: (
        dimension: string,
        dimensionValue: DimensionValue | undefined,
        onLastLevelClick?: OnLastLevelClickAction,
    ) => (() => void) | undefined;
    prevCampaignLabel: string;
    scoreDetailBuilder?: ScoreDetailBuilder;
    drilldownState: Drilldown;
    tabConfig: TabConfig;
    scoreWithVariations?: ScoreWithVariation[];
    ssqVersion?: SsqVersion;
    isLoading?: boolean;
    scoreQueryState?: ScoreDetailRemoteState;
    scoreQueryError?: unknown;
    retryScoreQuery?: () => Promise<unknown>;
};

export type FetchPostForAnswers = () => Promise<{ data: Post | GetOnePost | undefined }>;

export const ScoreDetailContext = createContext<ScoreDetailContextInitialValues | null>(null);
